import { render, staticRenderFns } from "./insaList.vue?vue&type=template&id=b33853b0"
import script from "./insaList.vue?vue&type=script&lang=js"
export * from "./insaList.vue?vue&type=script&lang=js"
import style0 from "./insaList.vue?vue&type=style&index=0&id=b33853b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports